import { useEffect } from "react";

interface SchemaJsonLDProps {
  schema: Record<string, unknown> | Record<string, unknown>[];
  id: string;
}

export default function SchemaJsonLD({ schema, id }: SchemaJsonLDProps) {
  useEffect(() => {
    const scriptId = `schema-jsonld-${id}`;
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, [schema, id]);

  return null;
}
